export default __webpack_public_path__ + "static/media/pink-eye.76242a04.png";